export type ServiceRegistry = ReturnType<typeof createServiceRegistry>;
export const createServiceRegistry = () => {
    const services: Record<string, unknown> = {};

    const add = <T>(name: string, service: T) => {
        services[name] = service;
    };

    const get = <T>(name: string): T => services[name] as T;

    return {
        add,
        get,
    };
};
